import type { CaseStudyContent } from './caseDetails';

export const lawFirmCase = {
  "eyebrow": "律师行业 GEO 案例",
  "summary": "一家中心城市的中型律所，围绕复杂财产分割离婚案件和刑事辩护整理专业信息。项目方反馈，聚焦两类需求后，每周持续收到来自 AI 推荐的咨询；数量、统计周期及委托金额未公开。",
  "keywords": [
    "律师行业GEO",
    "中型律所",
    "婚姻家事",
    "复杂财产分割",
    "刑事辩护"
  ],
  "metrics": [
    {
      "value": "2 类",
      "label": "重点业务方向",
      "note": "复杂财产分割、刑事辩护"
    },
    {
      "value": "每周",
      "label": "咨询反馈频率",
      "note": "项目方反馈，数量未披露"
    },
    {
      "value": "AI 推荐",
      "label": "咨询来源反馈",
      "note": "平台与核验方式未披露"
    },
    {
      "value": "中型律所",
      "label": "案例主体",
      "note": "城市及人员信息匿名"
    }
  ],
  "overview": [
    {
      "label": "机构背景",
      "value": "中心城市的一家中型律师事务所"
    },
    {
      "label": "业务基础",
      "value": "相关领域的核心律师与代表性案件经验"
    },
    {
      "label": "婚姻家事",
      "value": "涉及复杂财产关系的离婚案件"
    },
    {
      "label": "刑事业务",
      "value": "依据律师实际经验开展辩护咨询"
    }
  ],
  "channelsTitle": "竞争背景：具体需求中的专业匹配",
  "channelsDescription": "原案例未提供投放或流量数据，以下按客户选择过程整理。",
  "channelHeaders": [
    "选择场景",
    "已有基础",
    "信息表达任务"
  ],
  "channels": [
    {
      "channel": "综合律所推荐",
      "traffic": "大型机构具有品牌积累",
      "challenge": "让中型律所的专长有清晰入口"
    },
    {
      "channel": "婚姻家事咨询",
      "traffic": "复杂财产分割经验",
      "challenge": "说明业务经验与需求的关联"
    },
    {
      "channel": "刑事律师选择",
      "traffic": "核心律师与案件积累",
      "challenge": "便于核实执业信息和服务范围"
    }
  ],
  "painPoints": [
    {
      "title": "规模与专业匹配不同",
      "description": "综合知名度不能完整表达适合承接的业务。"
    },
    {
      "title": "服务名称过于笼统",
      "description": "用户需要了解律师能够处理的具体问题。"
    },
    {
      "title": "经验需要事实支撑",
      "description": "介绍应有可公开、可核验的资料对应。"
    },
    {
      "title": "咨询与委托需要区分",
      "description": "咨询反馈不等于已经签约或产生收入。"
    }
  ],
  "strategies": [
    {
      "step": "策略一",
      "title": "将已有专长转化为业务场景",
      "description": "围绕两个方向组织用户问题。",
      "items": [
        "婚姻家事：财产关系、资料准备与相关经验",
        "刑事辩护：业务范围、诉讼阶段与初次咨询"
      ]
    },
    {
      "step": "策略二",
      "title": "关联律师、经验与服务",
      "description": "以可核验信息支持选择。",
      "items": [
        "介绍执业信息和实际业务",
        "整理允许公开的案件经验，提供官方联系入口"
      ]
    },
    {
      "step": "策略三",
      "title": "按真实反馈记录进展",
      "description": "保持信息与业务事实一致。",
      "items": [
        "不编制排名，不把既往结果写成保证",
        "保护客户信息，区分咨询、需求和正式委托"
      ]
    }
  ],
  "resultsTitle": "咨询反馈：已知信息与统计范围",
  "resultHeaders": [
    "观察项",
    "信息起点",
    "已披露反馈",
    "统计说明"
  ],
  "results": [
    {
      "dimension": "咨询持续性",
      "before": "初期基线未披露",
      "after": "每周持续收到咨询",
      "change": "数量及持续周期未公开"
    },
    {
      "dimension": "咨询来源",
      "before": "初期结构未披露",
      "after": "项目方反馈来自 AI 推荐",
      "change": "平台与核验方法未公开"
    },
    {
      "dimension": "正式委托",
      "before": "初期签约数据未披露",
      "after": "未提供委托或收入数据",
      "change": "不能由咨询推算成交"
    }
  ],
  "businessOutcomes": [
    "反馈已涉及咨询环节，超出品牌曝光观察。",
    "两类业务各自贡献的咨询占比尚未披露。"
  ],
  "takeaways": [
    "明确具体服务需求，再组织专业介绍。",
    "以真实资质和经验支持客户选择。",
    "分别统计咨询反馈与签约结果。"
  ],
  "disclaimer": "根据来源页面整理，效果为项目方反馈；独立归因、具体数量及统计周期未披露。配图为概念示意，不代表实际律所、律师或案件，也不构成结果承诺。",
  "images": {
    "hero": {
      "src": "/case-details/law-geo/00-hero.jpg",
      "alt": "律师行业案例概念图",
      "caption": "原案例概念配图，非实际律所、律师或案件材料。"
    },
    "overview": {
      "src": "/case-details/law-geo/01-context.jpg",
      "alt": "中型律所专业匹配示意",
      "caption": "原案例概念配图，非实际律所、律师或案件材料。"
    },
    "channels": {
      "src": "/case-details/law-geo/02-scenes.jpg",
      "alt": "婚姻家事与刑事辩护示意",
      "caption": "原案例概念配图，非实际律所、律师或案件材料。"
    },
    "strategy": {
      "src": "/case-details/law-geo/03-evidence.jpg",
      "alt": "律师信息与业务经验示意",
      "caption": "原案例概念配图，非实际律所、律师或案件材料。"
    },
    "results": {
      "src": "/case-details/law-geo/05-results.jpg",
      "alt": "AI 推荐咨询反馈示意",
      "caption": "原案例概念配图，非实际律所、律师或案件材料。"
    },
    "takeaways": {
      "src": "/case-details/law-geo/04-boundaries.jpg",
      "alt": "法律服务信息表达边界示意",
      "caption": "原案例概念配图，非实际律所、律师或案件材料。"
    }
  }
} satisfies CaseStudyContent;
